import Seat from '../../../components/Seat';
import WagonTable from '../../../components/WagonTable';
import WagonToilet from '../../../components/WagonToilet';
import WagonBaggage from '../../../components/WagonBaggage';
import WagonDoor from '../../../components/WagonDoor';

function FirstFloor({
  seats,
  chosenSeats,
  setChosenSeats,
  wagonNumber,
  reserveSeat,
  unReserveSeat,
}) {
  return (
    <div>
      <div className="wagon">
        <div className="wagon-floor">
          <h2>I</h2>
        </div>

        <div
          className="seats-row left"
          style={{ width: '755.3px', marginLeft: '80px' }}
        >
          <WagonDoor />
          <WagonToilet />
          {[
            [2, 1],
            [7, 6, 5],
            [12, 11, 10],
            [17, 16, 15],
            [22, 21, 20],
            [27, 26, 25],
            [32, 31, 30],
            [37, 36, 35],
          ]?.map((seatRow) => (
            <div
              className="seat-column"
              key={seatRow[0]}
            >
              {seatRow[2] && (
              <Seat
                seat={seats?.[seatRow[2]]}
                chosenSeats={chosenSeats}
                setChosenSeats={setChosenSeats}
                wagonNumber={wagonNumber}
                reserveSeat={reserveSeat}
                unReserveSeat={unReserveSeat}
              />
              )}
              <Seat
                seat={seats?.[seatRow[1]]}
                chosenSeats={chosenSeats}
                setChosenSeats={setChosenSeats}
                wagonNumber={wagonNumber}
                reserveSeat={reserveSeat}
                unReserveSeat={unReserveSeat}
              />
              <Seat
                seat={seats?.[seatRow[0]]}
                chosenSeats={chosenSeats}
                setChosenSeats={setChosenSeats}
                wagonNumber={wagonNumber}
                reserveSeat={reserveSeat}
                unReserveSeat={unReserveSeat}
                bottom
              />
            </div>
          ))}
          <WagonTable
            style={{ display: 'flex', alignItems: 'center' }}
          />
          {[
            [40, 41, 42],
            [45, 46, 47],
            [50, 51, 52],
            [55, 56, 57],
            [60, 61, 62],
            [65, 66, 67],
            [70, 71, 72],
            [75, 76, 77],
          ]?.map((seatRow) => (
            <div
              className={`seat-column reversed ${!seatRow[2] && 'justify-end'}`}
              key={seatRow[0]}
            >
              {seatRow[2] && (
              <Seat
                seat={seats?.[seatRow[2]]}
                chosenSeats={chosenSeats}
                setChosenSeats={setChosenSeats}
                wagonNumber={wagonNumber}
                reserveSeat={reserveSeat}
                unReserveSeat={unReserveSeat}
              />
              )}
              <Seat
                seat={seats?.[seatRow[1]]}
                chosenSeats={chosenSeats}
                setChosenSeats={setChosenSeats}
                wagonNumber={wagonNumber}
                reserveSeat={reserveSeat}
                unReserveSeat={unReserveSeat}
              />
              <Seat
                seat={seats?.[seatRow[0]]}
                chosenSeats={chosenSeats}
                setChosenSeats={setChosenSeats}
                wagonNumber={wagonNumber}
                reserveSeat={reserveSeat}
                unReserveSeat={unReserveSeat}
                bottom
              />
            </div>
          ))}
          <WagonBaggage />
          <WagonDoor />
        </div>
        <div
          className="seats-row bottom left"
          style={{ width: '755.3px', marginLeft: '80px' }}
        >
          <WagonDoor />
          <WagonToilet />
          {[
            [4, 3],
            [9, 8],
            [14, 13],
            [19, 18],
            [24, 23],
            [29, 28],
            [34, 33],
            [39, 38],
          ]?.map((seatRow) => (
            <div
              className="seat-column"
              key={seatRow[0]}
            >
              <Seat
                seat={seats?.[seatRow[1]]}
                chosenSeats={chosenSeats}
                setChosenSeats={setChosenSeats}
                wagonNumber={wagonNumber}
                reserveSeat={reserveSeat}
                unReserveSeat={unReserveSeat}
              />
              <Seat
                seat={seats?.[seatRow[0]]}
                chosenSeats={chosenSeats}
                setChosenSeats={setChosenSeats}
                wagonNumber={wagonNumber}
                reserveSeat={reserveSeat}
                unReserveSeat={unReserveSeat}
                bottom
              />
            </div>
          ))}
          <WagonTable
            style={{ display: 'flex', alignItems: 'center' }}
          />

          {[
            [43, 44],
            [48, 49],
            [53, 54],
            [58, 59],
            [63, 64],
            [68, 69],
            [73, 74],
            [78, 79],
            [80, 81],
          ]?.map((seatRow) => (
            <div
              className="seat-column reversed"
              key={seatRow[0]}
            >
              <Seat
                seat={seats?.[seatRow[1]]}
                chosenSeats={chosenSeats}
                setChosenSeats={setChosenSeats}
                wagonNumber={wagonNumber}
                reserveSeat={reserveSeat}
                unReserveSeat={unReserveSeat}
              />
              <Seat
                seat={seats?.[seatRow[0]]}
                chosenSeats={chosenSeats}
                setChosenSeats={setChosenSeats}
                wagonNumber={wagonNumber}
                reserveSeat={reserveSeat}
                unReserveSeat={unReserveSeat}
                bottom
              />
            </div>
          ))}
          <WagonDoor />
        </div>
      </div>
    </div>
  );
}

export default FirstFloor;
